export default "__VITE_ASSET__CSGMPDtE__"